import "../../styles/CertificatePreview.css";

function CertificatePreview({ type, eyebrow, title, folio, sections, isActive, slideDirection }) {
    return (
        <article
            className={`certificate-preview certificate-preview-${type}${isActive ? ` certificate-preview-active certificate-preview-slide-${slideDirection}` : ""}`}
            aria-label={`${title}, vista ilustrativa`}
        >
            <header className="certificate-preview-header">
                <span>{eyebrow}</span>
                <h3>{title}</h3>
                <div className="certificate-preview-folio">
                    <span>FOLIO</span>
                    <strong>{folio}</strong>
                </div>
            </header>

            <div className="certificate-preview-content">
                {sections.map(({ title: sectionTitle, rows }) => (
                    <section className="certificate-preview-section" key={sectionTitle}>
                        <h4>{sectionTitle}</h4>
                        {rows.map(([label, value]) => (
                            <div className="certificate-preview-row" key={label}>
                                <span>{label}</span>
                                <strong>{value}</strong>
                            </div>
                        ))}
                    </section>
                ))}
            </div>

            <footer className="certificate-preview-footer">
                <span>VISTA ILUSTRATIVA</span>
                <span className="certificate-preview-seal" aria-hidden="true" />
            </footer>
        </article>
    );
}

export default CertificatePreview;